/* ==========================================================================
   BHG shared scripts
   --------------------------------------------------------------------------
   One labelled block per page layout that lives in a page's own HTML (those
   pages have no snippet to carry their scripts). Every block checks for its
   page's wrapper first and does nothing elsewhere, so the file is safe to
   load on every page. A component's own script stays inside its snippet.

   Loaded once from layout/theme.liquid with defer, so the page is parsed
   before any block runs. Plain JavaScript: no Liquid, no libraries.

   Theme hooks (selectors for theme markup) sit as constants at the top of
   the block that needs them, so a new theme changes those lines only.
   ========================================================================== */


/* ==========================================================================
   CONTACT PAGE (/pages/contact, built as contact-new)
   --------------------------------------------------------------------------
   Runs only when the page's wrapper (.bhg-ct) is present.
     - Header offset: measures the sticky header so "#message-form" lands
       below it.
     - Hours: reads the times shown in the hours table and marks today's row
       and the open/closed status (Eastern time).
     - Copy buttons: [data-bhg-copy] copies its value; falls back to
       selecting the text next to it.
   ========================================================================== */
(function () {
  /* Theme hook: the sticky header, measured so "#message-form" lands below it. */
  var HEADER = '.shopify-section-group-header-group.c-h-header';

  var page = document.querySelector('.bhg-ct');
  if (!page) return;

  function setHeaderOffset() {
    var h = document.querySelector(HEADER);
    page.style.setProperty('--bhg-ct-hdr', (h ? Math.round(h.getBoundingClientRect().height) : 0) + 'px');
  }
  setHeaderOffset();
  window.addEventListener('resize', setHeaderOffset);

  /* ---------- open / closed, read from the hours table ---------- */
  var DAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function toMinutes(text) {
    var m = /(\d{1,2})(?::(\d{2}))?\s*([AP])\.?M/i.exec(text || '');
    if (!m) return null;
    var h = parseInt(m[1], 10) % 12;
    if (m[3].toUpperCase() === 'P') h += 12;
    return h * 60 + (m[2] ? parseInt(m[2], 10) : 0);
  }
  function readHours() {
    var out = {};
    page.querySelectorAll('[data-bhg-hours] tr[data-day]').forEach(function (tr) {
      var td = tr.querySelectorAll('td');
      var open = td[1] ? toMinutes(td[1].textContent) : null;
      var close = td[2] ? toMinutes(td[2].textContent) : null;
      out[tr.getAttribute('data-day')] = (open === null || close === null) ? null : { open: open, close: close, label: td[1].textContent.trim() };
    });
    return out;
  }
  function easternNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
      var get = function (t) { for (var i = 0; i < parts.length; i++) { if (parts[i].type === t) return parts[i].value; } return ''; };
      return { day: DAYS[get('weekday')], min: (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10) };
    } catch (e) {
      var n = new Date();
      return { day: n.getDay(), min: n.getHours() * 60 + n.getMinutes() };
    }
  }
  function shortTime(min) {
    var h = Math.floor(min / 60), m = min % 60, x = h % 12 || 12;
    return x + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ' ' + (h >= 12 ? 'PM' : 'AM');
  }
  function renderStatus() {
    var hours = readHours(), now = easternNow(), today = hours[now.day];
    var open = !!today && now.min >= today.open && now.min < today.close, detail = '';
    if (open) {
      detail = 'Until ' + shortTime(today.close) + ' ET today';
    } else if (today && now.min < today.open) {
      detail = 'Opens today at ' + shortTime(today.open) + ' ET';
    } else {
      for (var i = 1; i <= 7; i++) {
        var d = (now.day + i) % 7, next = hours[d];
        if (next) {
          detail = 'Opens ' + (i === 1 ? 'tomorrow' : DAY_NAMES[d]) + ' at ' + shortTime(next.open) + ' ET';
          break;
        }
      }
    }
    page.querySelectorAll('[data-bhg-status]').forEach(function (el) {
      el.setAttribute('data-state', open ? 'open' : 'closed');
      el.querySelector('.bhg-ct__st-label').textContent = open ? 'Open now' : 'Closed now';
      el.querySelector('.bhg-ct__st-detail').textContent = detail;
    });
    page.querySelectorAll('[data-bhg-hours] tr[data-day]').forEach(function (tr) {
      tr.classList.toggle('is-today', +tr.getAttribute('data-day') === now.day);
    });
  }
  renderStatus();
  setInterval(renderStatus, 60000);

  /* ---------- copy buttons ---------- */
  page.querySelectorAll('[data-bhg-copy]').forEach(function (btn) {
    var label = btn.textContent;
    function flash(text, done) {
      btn.textContent = text;
      btn.classList.toggle('is-done', !!done);
      setTimeout(function () { btn.textContent = label; btn.classList.remove('is-done'); }, 1800);
    }
    function selectText() {
      var t = btn.parentNode.querySelector('[data-bhg-copy-text]');
      if (!t) return;
      var r = document.createRange(); r.selectNodeContents(t);
      var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
      flash('Selected');
    }
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-bhg-copy');
      try {
        navigator.clipboard.writeText(text).then(function () { flash('Copied', true); }, selectText);
      } catch (e) { selectText(); }
    });
  });
})();
